<lib-digital-queue-page [id]="id"></lib-digital-queue-page>